'use strict';
	var ajax = require('../../ajax'),
		dialog = require('../../dialog'),
		jcalendar = require('../../jcalendar'),
		util = require('../../util');

	var shutlMethodId = SitePreferences.SHUTL_METHOD_ID;
/**
 * @function
 * @descr initialize shipping methods events handlers for all shipments or
 * for given single shipment (once updated, for example, after ajax call
 */
function initializeEventHandlers ($form) {

	var $multishipForm = $form || $('form.checkout-multi-shipping');

	//main shipping methods dropdown
	$multishipForm.find('select[name$="_shippingMethodID"]').on('change', function () {
		var $mainContainer = $(this).closest('.shipping-methods'),
			$selectedMethod = $('option:selected', this);

		//if methods has been changed under the hood do nothing @see selectMainShippingMethod
		if ($(this).hasClass('updated')) {
			$(this).removeClass('updated');
			return;
		}

		if ($selectedMethod.hasClass('has-dependent-methods')) {
			$mainContainer.find('.nominated-selection').hide();
			showDependentMethods($selectedMethod, $mainContainer);
		} else {
			resetShipmentDependentMethods($mainContainer);
		}
	});

	$multishipForm.find('select[name$="_shippingMethodID"]').each(updateOnloadDependentShippingMethods);

	//events dropdown of ARRIVEBY nominatedType
	$multishipForm.find('.nominated-selection.arrival').on('change', '.event-details', function () {
		var $realDateField = $(this).closest('.nominated-selections').find('[name$="nominatedDate"]'),
			$container = $(this).closest('.nominated-selection'),
			$calendar = $container.find('.nominated-date'),
			selectedValue =  $(this).val();

		if (selectedValue) {
			// reset calendar
			$calendar.val('');
			$container.find('.ui-datepicker-bottom-content').hide();
			toggleRequiredForCalendar($calendar, false);
			//update real date and get methods
			$realDateField.val(selectedValue);
			$container.find('.chosen-date').show().find('.date').text(selectedValue);
			updateDependentMethod($(this));
		} else {
			toggleRequiredForCalendar($calendar, true);
			$container.find('.chosen-date').hide();
		}
	});

	//calendar handler of ARRIVEBY nominatedType
	$multishipForm.find('.nominated-selection.arrival').on('change', '.nominated-date', function () {
		var $realDateField = $(this).closest('.nominated-selections').find('[name$="nominatedDate"]'),
			$container = $(this).closest('.nominated-selection'),
			$eventsSelector = $container.find('.event-details'),
			selectedValue =  $(this).val();
		//reset events select & update main shipping method
		if (selectedValue) {
			$realDateField.val(selectedValue);
			$eventsSelector.val($eventsSelector.find('option:first').val());
			$.uniform.update($eventsSelector);
			$container.find('.chosen-date').hide();
			updateDependentMethod($(this));
		}
	});

	//calendar handler of time nominatedType
	$multishipForm.find('.nominated-selection.time').on('change', '.nominated-date', function () {
		var $realDateField = $(this).closest('.nominated-selections').find('[name$="nominatedDate"]'),
			selectedValue = $(this).val();

		$realDateField.val(selectedValue);
		updateDependentMethod($(this));

	});
	//radio buttons of time dependent methods
	$multishipForm.find('.nominated-selection').on('change', '.dependent-method', function () {
		if ($(this).is(':checked')) {
			selectMainShippingMethod(
					$(this).closest('.nominated-selection'),
					$(this).val()
				);
		} else {
			$(this).closest('.dependent-methods').hide();
		}
	});

	if ($multishipForm.find('.shutl-quote-container').length > 0) {
		initShutl();
	}
	$('.shipping-method').each(function () {
		var el = $(this).find('.nominated-date');
		var displayDate = $(this).find('.arrive-by-date');
		var inputNominatedDate = $(this).parents('.shipping-methods').find('input[name$="_nominatedDate"]');
		var excludedDaysOfWeek = $(this).find('.excluded-dates').val();
		jcalendar.init(el, {
			'container': $(this),
			'excludedDates': SitePreferences.EXCLUDED_DATES,
			'minDate': el.get(0).value,
			'excludedDaysOfWeek': excludedDaysOfWeek,
			'closeButtonNeeded': true,
			'callback': function () {
				var arrivalDateArr = el.val().split("/");
				var arrivalDate = new Date(arrivalDateArr[2], arrivalDateArr[1] - 1, arrivalDateArr[0]);
				var tomorrowDate = new Date();
				tomorrowDate.setDate(tomorrowDate.getDate() + 1);
				if (tomorrowDate.toDateString() === arrivalDate.toDateString()) {
					displayDate.text('Tomorrow');
				} else {
					var dateFormatted = arrivalDate.toLocaleString('en-GB', {
						weekday: 'short',
						day: 'numeric',
						month: 'short',
					});
					displayDate.text(dateFormatted);
				}

				displayDate.attr('data-arrival-date', el.val());
				inputNominatedDate.val(el.val());
			}
		});
	});

	$('.edit-sms').each(function () {
		var el = $(this).find('.datepicker-checkout-sms');
		jcalendar.init(el, {'container': $(this)});
	});
}
function toggleRequiredForCalendar ($calendar, isRequired) {
	var validator = $calendar.closest('form').validate();
	if (isRequired) {
		$calendar.addClass('required');
	} else {
		$calendar.removeClass('required');
		validator.element($calendar);
	}
}
/**
 * @function
 * @descr main shipping methods dropdown handler activate dependent methods
 *
 * @param $selectedMethod chosen shipping method that has dependent methods
 * @param $container shipment methods container for given shipment
 */
function showDependentMethods ($selectedMethod, $mainContainer) {
	var $container = $mainContainer.find('[data-base-method="' + $selectedMethod.data('base-method') + '"]'),
		$calendarField = $container.find('.nominated-date'),
		$checkedMethod = $container.find('.dependent-method:checked');

	if ($calendarField.length) {
		jcalendar.init($calendarField, {
			'excludedDates': SitePreferences.EXCLUDED_DATES,
			'excludeSaturday': $selectedMethod.data('exclude-saturday'),
			'excludeSunday': true,
			'maxDate': $calendarField.attr('max'),
			'minDate': $calendarField.attr('min'),
			'container': $container
		});
	}

	// show date and radio buttons if a nominated shipping method is selected
	if ($checkedMethod.length) {
		$checkedMethod.closest('.dependent-methods').show();
		$checkedMethod.trigger('change');
	}

	$container.show();
	$.uniform.update($container.find('.event-details'));
}

/**
 * @function
 * @descr if selected shipment method does not have dependent methods,
 * reset all dependent methods fields
 */
function resetShipmentDependentMethods ($container) {
	var $dependentMethods = $container.find('.nominated-selection');
	$dependentMethods
		.hide()
		.find('.nominated-date, .event-details').val('');
	$dependentMethods
		.find('.ui-datepicker-bottom-content, .chosen-date').hide();
	$dependentMethods
		.find('.dependent-method:checked').prop('checked', false).trigger('change');
	$.uniform.update($dependentMethods.find('.dependent-method'));
}

// TODO remove this method and it using
function updateDependentMethod ($nominatedDate) {
	// The date and shipment info are sent to check eligible nominated type
	var selectedDate = $nominatedDate.val(),
		$container = $nominatedDate.closest('.nominated-selection'),
		baseMethod = $container.data('base-method'),
		params = {date: selectedDate, method: baseMethod, shipment: $container.data('shipment')},
		// TODO COShippingMultiple-GetNominated will be removed
		getNominatedUrl = util.appendParamsToUrl(Urls.getNominatedShipment, params);

	ajax.getJson({
		url: getNominatedUrl,
		callback: function (data) {
			// Hide time radio inputs and then show the div for the nominated type
			var $nominatedSelection = $nominatedDate.closest('.nominated-selection'),
				$dependantMethodContainer = $nominatedSelection.find('.dependent-methods.' + data.type);

			// clearNominatedValue($nominatedSelections.data('select'));
			$nominatedSelection.find('.dependent-methods').hide();

			// If an option is found, show the options and select the first one
			if (data.success && $dependantMethodContainer.length > 0) {
				//$('.checkout-multi-shipping').validate().element($nominatedDate);
				// hide each method that is not in data.allowedMethods[data.type] and pick first one
				if (data.allowedMethods[data.type] && data.allowedMethods[data.type].length >= 1) {
					var haveSelected = false;
					var methods = data.allowedMethods[data.type];
					var current = $dependantMethodContainer.find('.dependent-method:checked');
					// live current box as selected if it's avaible otherwise uncheck all and pick fist available
					if (current && methods.indexOf($(current.closest('.dep_methd_wrapper')).attr('shipping')) >= 0) {
						haveSelected = true;
					} else {
						$(current).prop('checked', false);
						$dependantMethodContainer.find('span.checked').toggleClass('checked');
					}
					$dependantMethodContainer.find('.dep_methd_wrapper').each(function (index, method) {
						if (methods.indexOf($(method).attr('shipping')) < 0) {
							$(method).hide();
						} else {
							var $methodInput = $(method).find('.dependent-method');
							if (!haveSelected) {
								haveSelected = true;
								$methodInput.prop('checked', true).trigger('change');
								$.uniform.update($methodInput);
							}
							$(method).show();
						}
					});
					$dependantMethodContainer.show();
				} else {
					// Check the first radio button for this nominated type if none are selected
					if ($nominatedSelection.find('.' + data.type).find('.dependent-method:checked').length === 0) {
						var $firstMethod = $dependantMethodContainer.find('.dependent-method').first();
						$firstMethod.prop('checked', true).trigger('change');
						$.uniform.update($firstMethod);
					}
				}
			} else if (data.success && (data.type === 'ARRIVEBY' || data.type === 'NOMINATED')) {
				// if no dependent methods, use the base method
				selectMainShippingMethod($nominatedSelection, $nominatedSelection.data('base-method'));
			} else if (data.success) {
				// if a shipment is eligible for base method, but not a dependent method, show error pop-up
				// this will happen for next day and Saturday dependent methods
				dialog.open({
					url: Urls.nominatedDateErrorMessage,
					options: {
						buttons: [
							{
								text: Resources.GOT_IT,
								'class':'button-gray',
								click: function () {
									$(this).dialog('close');
								}
							}
						],
						dialogClass: 'yes-and-no-dialog',
						title: Resources.SORRY
					}
				});
				$container.find('.event, .nominated-date').addClass('error');
			} else {
				// handle other shipping date errors
				var $realDateField = $container.closest('.nominated-selections').find('[name$="nominatedDate"]'),
					$calendar = $container.find('.nominated-date');
				$realDateField.val('');
				$container.find('.event, .nominated-date').val('');
				$container.find('.chosen-date, .ui-datepicker-bottom-content').hide();
				toggleRequiredForCalendar($calendar, true);
				$container.closest('form').validate().element($calendar);
			}
		}
	});
}
/**
 * if shipment method was chosen and needs to be displayed once the page is loaded
 */
function updateOnloadDependentShippingMethods () {
	var $shippingMethods = $(this).closest('.shipping-methods'),
		$selectedMethod = $('option:selected', this),
		$realDateField = $shippingMethods.find('[name$="nominatedDate"]'),
		$nominatedSM = $shippingMethods.find('.nominated-selection').filter('[data-base-method="' + $selectedMethod.data('base-method') + '"]'),
		$eventSelect = $nominatedSM.find('.event-details'),
		$selectedRadioButton = $shippingMethods.find('.dependent-method').filter(':checked'),
		$radiobuttonsContainer,
		isArrival = false,
		calendarField;
	//check radio buttons first
	if ($selectedRadioButton.length === 1) {
		$radiobuttonsContainer = $selectedRadioButton.closest('.nominated-selection');
		calendarField = $radiobuttonsContainer.find('.nominated-date');
		calendarField.val($realDateField.val());
		$radiobuttonsContainer.find('.ui-datepicker-bottom-content').show().find('.date').text($realDateField.val());
		$selectedRadioButton.closest('.dependent-methods').show();
		$radiobuttonsContainer.show();
		updateDependentMethod($(calendarField));
	} else if ($eventSelect.length && $nominatedSM.length) {
		isArrival = true;
		$eventSelect.find('option').each(function () {
			if ($(this).val() === $realDateField.val()) {
				isArrival = false;
				$eventSelect.val($realDateField.val());
				$nominatedSM.find('.chosen-date').show().find('.date').text($realDateField.val());
				$nominatedSM.show();
				$.uniform.update($eventSelect);
				calendarField = $nominatedSM.find('.nominated-date');
			}
		});
		if (isArrival) {
			calendarField = $nominatedSM.find('.nominated-date');
			calendarField.val($realDateField.val());
			$nominatedSM.find('.ui-datepicker-bottom-content').show().find('.date').text($realDateField.val());
			$nominatedSM.show();
			$.uniform.update($eventSelect);
		}
	}

	if (calendarField && calendarField.length && !calendarField.hasClass('hasDatepicker')) {
		jcalendar.init(calendarField, {
			'excludedDates': SitePreferences.EXCLUDED_DATES,
			'excludeSaturday': $selectedMethod.data('exclude-saturday'),
			'excludeSunday': true,
			'maxDate': calendarField.attr('max'),
			'minDate': calendarField.attr('min'),
			'container': $nominatedSM
		});
	}
}
/**
 * @function
 * @descr update selected option of the main shipping method dropdown with chosen dependent method
 * for arrive befor selectedMethod and base method are matched they just need to update values
 */
function selectMainShippingMethod($container, selectedMethod) {
	var baseMethod = $container.data('base-method'),
		selectID =  $container.closest('.nominated-selections').data('select'),
		shippingMethods = $container.closest('.shipping-methods').find('[name="' + selectID + '"]');

	shippingMethods
		.find('[data-base-method="' + baseMethod + '"]')
		.val(selectedMethod);
	shippingMethods
		.addClass('updated')
		.trigger('change');
}
/**
 * @function
 * @description Load the Shutl calendar for local delivery options.
 */
function initShutl() {
	// hide or show the shutl container based on the selected shipment method
	var toggleShutlContainer = function () {
		var $this = $(this);
		var $shutlContainer = $this.closest('.shipping-methods').find('.shutl-quote-container');
		$shutlContainer.toggle($this.val() === shutlMethodId);
	};

	// init events to show and hide Shutl Container with quote selection
	$('form.checkout-multi-shipping').find('select[name$="_shippingMethodID"]').on('change', toggleShutlContainer);
	$('form.checkout-multi-shipping').find('select[name$="_shippingMethodID"]').each(toggleShutlContainer);

	var handleQuoteSelection = function () {
		var $this = $(this);
		var $shutlContainer = $(this).closest('.shipping-methods').find('.shutl-quote-container');
		var selectedQuoteId = $this.val();
		var currentQuoteInput = $shutlContainer.find('input[name$="_selectedShutlQuoteID"]');
		if (selectedQuoteId === currentQuoteInput.val()) {
			return false;
		}

		var selectQuoteUrl = util.appendParamsToUrl(Urls.selectShutlQuote, {ShipmentUUID: $this.data('shipmentuuid'), QuoteId: selectedQuoteId});
		ajax.load({
			url: selectQuoteUrl,
			callback: function (response) {
				var responseObj = JSON.parse(response);
				if (!responseObj.success) {
					// failure case when setting the selected quote
					window.console.log('Delivery selection failed');
				} else {
					currentQuoteInput.val(selectedQuoteId);
				}
			}
		});
	};
	// init event handling to select quote
	$('.shipping-methods .shutl-quote-container').find('select[name$="_shutlQuoteID"]').on('change', handleQuoteSelection);
}

exports.init = initializeEventHandlers;
